import { useState } from 'react';
import { Button } from '@shared-ui/components';
import { SimulationDetail } from '@shared-ui/simulations';
import { adminSimulationsSource, simulationsApi, type Simulation } from '../../api/simulationsApi';
import { CurationEditor } from './CurationEditor';

/**
 * One simulation, as admin sees it: the shared detail page — the same one the
 * teacher app and the public site show — plus one button. Curation (status,
 * topics, board/grades) lives in a dialog rather than beneath the simulation,
 * so the page stays a faithful preview instead of a preview with a form
 * growing out of it.
 */
export function SimulationPlayer() {
  return (
    <SimulationDetail
      source={adminSimulationsSource}
      curation
      renderActions={(sim, replace) => <EditMetadata sim={sim} onSaved={replace} />}
    />
  );
}

function EditMetadata({ sim, onSaved }: { sim: Simulation; onSaved: (s: Simulation) => void }) {
  const [editing, setEditing] = useState(false);
  return (
    <>
      <Button size="sm" variant="secondary" onClick={() => setEditing(true)}>
        Edit metadata
      </Button>
      {/* The editor brings its own dialog — the Save it owns belongs in that
          dialog's footer, and only it knows whether there is anything to save. */}
      <CurationEditor entry={sim} isOpen={editing} onClose={() => setEditing(false)} save={simulationsApi.curate} onSaved={onSaved} />
    </>
  );
}
